export const DEFAULT_DAMAGE_INSPECTION_LOCALE = 'sl';

export const DAMAGE_INSPECTION_TRANSLATIONS: Record<string, Record<string, string>> = {
  sl: {
    notAvailable: 'Poročilo o škodi za to vozilo trenutno ni na voljo.',
    tyresTitle: 'Pnevmatike',
    tyreDepth: 'Globina profila',
    'tyreLocation_front-left': 'Sprednja levo',
    'tyreLocation_front-right': 'Sprednja desno',
    'tyreLocation_back-left': 'Zadnja levo',
    'tyreLocation_back-right': 'Zadnja desno',
    breadcrumb: 'Vozilo · Poročilo o škodi',
    close: 'Zapri',
    print: 'Natisni',
    share: 'Deli povezavo',
    shareCopied: 'Povezava kopirana',
    shareCopyFailed: 'Povezave ni bilo mogoče kopirati – prosimo, kopirajte jo ročno iz naslovne vrstice.',
    pdfFailed: 'PDF poročila ni bilo mogoče ustvariti. Poskusite znova.',
    export: 'Izvozi',
    totalDamage: 'Ocena škode',
    vin: 'VIN',
    reportDate: 'Datum poročila',
    location: 'Lokacija vozila',
    inspectedBy: 'Pregledal',
    inspectionDate: 'Datum pregleda',
    reviewedBy: 'Revidiral',
    revisionDate: 'Datum revizije',
    sectionExterior: 'Zunanje poškodbe',
    sectionInterior: 'Notranje poškodbe',
    sectionOther: 'Druge škode',
    damageCost: 'Znesek škode',
    comment: 'Komentar',
    'status_damaged': 'Lažje poškodovano',
    'ageType_new': 'Novo vozilo',
    'ageType_used': 'Rabljeno vozilo',
    'ageType_test': 'Testno vozilo',
    'ageType_young': 'Rabljeno mlado vozilo',
    'fuelType_cng_gas': 'CNG plin',
    'fuelType_diesel': 'Dizel',
    'fuelType_electric': 'Električni pogon',
    'fuelType__electric': 'Električni pogon',
    'fuelType_gas': 'Plin',
    'fuelType_gasoline': 'Bencin',
    'fuelType_hybrid': 'Hibridni pogon',
    'fuelType_plugin_hybrid': 'Priključni hibrid (plug-in)',
    'fuelType_lpg_gas': 'UNP plin',
    'transmissionType_automatic': 'Avtomatski',
    'transmissionType_manual': 'Ročni',
    'transmissionType_semi-automatic': 'Poloavtomatski',
    'transmissionType_steptronic-tiptronic': 'Steptronic/Tiptronic',
    'transmissionType_steptronic_tiptronic': 'Steptronic/Tiptronic',
    footerCopyright: 'Vse pravice pridržane',
  },
  en: {
    notAvailable: 'A damage inspection report is not currently available for this vehicle.',
    tyresTitle: 'Tyres',
    tyreDepth: 'Tread depth',
    'tyreLocation_front-left': 'Front left',
    'tyreLocation_front-right': 'Front right',
    'tyreLocation_back-left': 'Rear left',
    'tyreLocation_back-right': 'Rear right',
    breadcrumb: 'Vehicle · Damage report',
    close: 'Close',
    print: 'Print',
    share: 'Share link',
    shareCopied: 'Link copied',
    shareCopyFailed: 'Could not copy the link — please copy it manually from the address bar.',
    pdfFailed: 'The PDF could not be created. Please try again.',
    export: 'Export',
    totalDamage: 'Damage estimate',
    vin: 'VIN',
    reportDate: 'Report date',
    location: 'Vehicle location',
    inspectedBy: 'Inspected by',
    inspectionDate: 'Inspection date',
    reviewedBy: 'Reviewed by',
    revisionDate: 'Revision date',
    sectionExterior: 'Exterior damages',
    sectionInterior: 'Interior damages',
    sectionOther: 'Other damages',
    damageCost: 'Damage cost',
    comment: 'Comment',
    'status_damaged': 'Lightly damaged',
    'ageType_new': 'New vehicle',
    'ageType_used': 'Used vehicle',
    'ageType_test': 'Test vehicle',
    'ageType_young': 'Young used vehicle',
    'fuelType_cng_gas': 'CNG natural gas',
    'fuelType_diesel': 'Diesel',
    'fuelType_electric': 'Electric drive',
    'fuelType__electric': 'Electric drive',
    'fuelType_gas': 'Gas',
    'fuelType_gasoline': 'Petrol',
    'fuelType_hybrid': 'Hybrid drive',
    'fuelType_plugin_hybrid': 'Plug-in hybrid',
    'fuelType_lpg_gas': 'LPG Autogas',
    'transmissionType_automatic': 'Automatic',
    'transmissionType_manual': 'Manual',
    'transmissionType_semi-automatic': 'Semi-automatic',
    'transmissionType_steptronic-tiptronic': 'Steptronic/Tiptronic',
    'transmissionType_steptronic_tiptronic': 'Steptronic/Tiptronic',
    footerCopyright: 'All rights reserved',
  },
  hr: {
    notAvailable: 'Izvješće o oštećenjima trenutno nije dostupno za ovo vozilo.',
    tyresTitle: 'Gume',
    tyreDepth: 'Dubina profila',
    'tyreLocation_front-left': 'Prednja lijevo',
    'tyreLocation_front-right': 'Prednja desno',
    'tyreLocation_back-left': 'Zadnja lijevo',
    'tyreLocation_back-right': 'Zadnja desno',
    breadcrumb: 'Vozilo · Izvješće o oštećenju',
    close: 'Zatvori',
    print: 'Ispiši',
    share: 'Podijeli poveznicu',
    shareCopied: 'Poveznica kopirana',
    shareCopyFailed: 'Poveznicu nije bilo moguće kopirati – kopirajte je ručno iz adresne trake.',
    pdfFailed: 'PDF izvješća nije bilo moguće izraditi. Pokušajte ponovno.',
    export: 'Izvoz',
    totalDamage: 'Procjena štete',
    vin: 'VIN',
    reportDate: 'Datum izvješća',
    location: 'Lokacija vozila',
    inspectedBy: 'Pregledao',
    inspectionDate: 'Datum pregleda',
    reviewedBy: 'Revidirao',
    revisionDate: 'Datum revizije',
    sectionExterior: 'Vanjska oštećenja',
    sectionInterior: 'Unutarnja oštećenja',
    sectionOther: 'Ostale štete',
    damageCost: 'Iznos štete',
    comment: 'Komentar',
    'status_damaged': 'Lakše oštećeno',
    'ageType_new': 'Novo vozilo',
    'ageType_used': 'Rabljeno vozilo',
    'ageType_test': 'Testno vozilo',
    'ageType_young': 'Rabljeno mlado vozilo',
    'fuelType_cng_gas': 'CNG plin',
    'fuelType_diesel': 'Dizel',
    'fuelType_electric': 'Električni pogon',
    'fuelType__electric': 'Električni pogon',
    'fuelType_gas': 'Plin',
    'fuelType_gasoline': 'Benzin',
    'fuelType_hybrid': 'Hibridni pogon',
    'fuelType_plugin_hybrid': 'Plug-in hibrid',
    'fuelType_lpg_gas': 'UNP plin',
    'transmissionType_automatic': 'Automatski',
    'transmissionType_manual': 'Ručni',
    'transmissionType_semi-automatic': 'Poluautomatski',
    'transmissionType_steptronic-tiptronic': 'Steptronic/Tiptronic',
    'transmissionType_steptronic_tiptronic': 'Steptronic/Tiptronic',
    footerCopyright: 'Sva prava pridržana',
  },
  de: {
    notAvailable: 'Für dieses Fahrzeug ist derzeit kein Schadensbericht verfügbar.',
    tyresTitle: 'Reifen',
    tyreDepth: 'Profiltiefe',
    'tyreLocation_front-left': 'Vorne links',
    'tyreLocation_front-right': 'Vorne rechts',
    'tyreLocation_back-left': 'Hinten links',
    'tyreLocation_back-right': 'Hinten rechts',
    breadcrumb: 'Fahrzeug · Schadensbericht',
    close: 'Schließen',
    print: 'Drucken',
    share: 'Link teilen',
    shareCopied: 'Link kopiert',
    shareCopyFailed: 'Der Link konnte nicht kopiert werden – bitte kopieren Sie ihn manuell aus der Adressleiste.',
    pdfFailed: 'Das PDF konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
    export: 'Exportieren',
    totalDamage: 'Schadensschätzung',
    vin: 'FIN',
    reportDate: 'Berichtsdatum',
    location: 'Fahrzeugstandort',
    inspectedBy: 'Geprüft von',
    inspectionDate: 'Prüfdatum',
    reviewedBy: 'Überprüft von',
    revisionDate: 'Überprüfungsdatum',
    sectionExterior: 'Außenschäden',
    sectionInterior: 'Innenschäden',
    sectionOther: 'Sonstige Schäden',
    damageCost: 'Schadenshöhe',
    comment: 'Kommentar',
    'status_damaged': 'Leicht beschädigt',
    'ageType_new': 'Neufahrzeug',
    'ageType_used': 'Gebrauchtfahrzeug',
    'ageType_test': 'Testfahrzeug',
    'ageType_young': 'Junges Gebrauchtfahrzeug',
    'fuelType_cng_gas': 'CNG Erdgas',
    'fuelType_diesel': 'Diesel',
    'fuelType_electric': 'Elektroantrieb',
    'fuelType__electric': 'Elektroantrieb',
    'fuelType_gas': 'Gas',
    'fuelType_gasoline': 'Benzin',
    'fuelType_hybrid': 'Hybridantrieb',
    'fuelType_plugin_hybrid': 'Plug-in-Hybrid',
    'fuelType_lpg_gas': 'LPG Autogas',
    'transmissionType_automatic': 'Automatik',
    'transmissionType_manual': 'Manuell',
    'transmissionType_semi-automatic': 'Halbautomatisch',
    'transmissionType_steptronic-tiptronic': 'Steptronic/Tiptronic',
    'transmissionType_steptronic_tiptronic': 'Steptronic/Tiptronic',
    footerCopyright: 'Alle Rechte vorbehalten',
  },
};
